<template>
  <div class="project-edit-dailog col-block block">
    <div class="form-container col-block width-full">
      <caseBase
        :ref="'form-main'"
        :mode="'analysis'"
        :isUpdate="!!param.project.id"
        :layoutBlocks="[
          'form',
          'analysis'
        ]"
        :dataset="isGVCF ? 'fastq' : caseData.dataset"
        :defaultData="defaultData"
        :projects="param.projects"
        @onError="error => onError = error"
        @unloadAlert="alert => unloadAlert = alert"
      >
        <template slot="analysis-update" slot-scope="props">
          <div class="analysis-update-container row-block" :name="props">
            <div :style="{ flex: 1 }"></div>
            <button type="button" class="main-button circle-button" :class="{ loading: onSubmit['info'] }" :disabled="!props.data.project.name" @click="e => !onSubmit['info'] && validateSendCase(false)">
              <span>{{ $t('COMMON.button.___update') }}</span>
            </button>
            <div :style="{ flex: 1 }"></div>
          </div>
        </template>
        <template slot="analysis-import" slot-scope="props">
          <div class="analysis-import-container col-block" :name="props">
            <customForm
              :init="importData"
              :layoutType="'grid'"
              :groupCount="6"
              :forms="formOptions['field1']"
              :scope="'import'"
              :reading="false"
              @change="result => selectedProjectID = result.import"
            >
              <template slot="IMPORT_BUTTON" slot-scope="props">
                <div class="IMPORT_BUTTON-container row-block" :name="props">
                  <button type="button" class="main-button circle-button" :disabled="!selectedProjectID" @click="e => importProject()">
                    <span>{{ $t('COMMON.button.___import') }}</span>
                  </button>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </template>
            </customForm>
          </div>
        </template>
      </caseBase>
    </div>
    <div :style="{ height: '15px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit['phenotype'] }" :disabled="false" @click="e => !onSubmit['phenotype'] && validateSendCase(true)">
        <span>{{ param.project.id ? $t('COMMON.button.___reanalysis') : $t('COMMON.button.___create') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  postProject,
  putProjectInfo,
  putProjectPhenotype
} from '../../api'
import caseBase from '../case/base.vue'
import customForm from '../tool/customForm.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import licenseManager from '../../mixins/licenseManager.vue'

export default {
  components: {
    caseBase,
    customForm
  },
  mixins: [
    toastMethods,
    licenseManager
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      caseData: {},
      analysisData: {},
      importData: {},
      selectedProjectID: null,
      onError: false,
      onSubmit: {
        info: false,
        phenotype: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    defaultData () {
      return {
        'case': this.caseData,
        'analysis': this.analysisData
      }
    },
    isGVCF () {
      return (((this.param.analysisFiles || {})['Analysis Files'] || {})['VCF file (SNV)'] || []).some(file => file.name.includes('.gvcf.'))
    },
    // static
    projectOptions () {
      return this.param.projects.map(project => ({ title: project.name, value: project.id }))
    },
    formOptions () {
      return {
        'field1': [
          {
            title: this.$t('DIALOG.projectEdit.form.title.___import'),
            value: 'import',
            type: 'select',
            grid: 2,
            options: this.projectOptions,
            disabled: () => false,
            placeholder: () => this.$t('DIALOG.projectEdit.form.placeholder.___import')
          },
          {
            title: '　',
            value: 'IMPORT_BUTTON',
            type: 'custom',
            grid: 4
          }
        ]
      }
    }
  },
  created () {
    this.caseData = {
      ...this.param.caseData
    }
    this.analysisData = {
      ...this.param.project
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction',
      'setModal2Action'
    ]),
    async importProject () {
      const keepKeyList = [
        'id',
        'name',
        'note',
        'report_phenovardb'
      ]
      let project = this.param.projects.find(project => project.id === this.selectedProjectID) || {}
      const forms = Object.entries(this.$refs).filter(([key]) => key.startsWith('form-')).map(([key, ref]) => ref[0] || ref)
      let datas = []
      for (let form of forms) {
        let data = await form.submit()
        if (form && !data) {
          throw new Error()
        } else {
          datas.push(data)
        }
      }
      let keepData = keepKeyList.reduce((data, key) => ({ ...data, [key]: datas[0].data.project[key] }), {})
      this.analysisData = {
        ...project,
        ...keepData
      }
    },
    async validateSendCase (isAnalysis) {
      if (await this.checkLicenseStatus(
        this.licenseTypeMap[this.caseData.dataset],
        today => (!today ? null : ['alert'])
      )) {
        try {
          const forms = Object.entries(this.$refs).filter(([key]) => key.startsWith('form-')).map(([key, ref]) => ref[0] || ref)
          let success = true
          for (let form of forms) {
            let result = await form.validateSubmit()
            if (form && !result) {
              success = false
            }
          }
          if (success) {
            let datas = []
            for (let form of forms) {
              let data = await form.submit()
              if (form && !data) {
                throw new Error()
              } else {
                datas.push(data)
              }
            }
            if (await this.checkAlerts()) {
              this.setLoadingAction(true)
              this.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = true
              await this.sendCase(datas[0], isAnalysis)
            }
          }
        } catch (error) {
        }
      }
    },
    async checkAlerts () {
      if (['Unknown'].includes(this.caseData.sex)) {
        if (!(await this.unknownSexAlert())) return
      }
      return true
    },
    async unknownSexAlert () {
      return new Promise(resolve => {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'alert',
            content: this.$t('DIALOG.projectEdit.modal.content.___unknownSexAlert'),
            buttons: [
              {
                title: this.$t('COMMON.button.___cancel'),
                type: 'gray',
                result: false
              },
              {
                title: this.$t('COMMON.button.___create'),
                type: 'alert',
                result: true
              }
            ]
          },
          callback: async result => {
            resolve(result)
          }
        })
      })
    },
    async sendCase (formData, isAnalysis) {
      let config = this.$ls.get('userInfo')
      let id = this.param.caseData.id
      let projectID = this.param.project.id
      let data = formData.data
      const sendCase = async () => {
        try {
          let response =
            !projectID ? await postProject(id, data.project, config)
            : isAnalysis ? await putProjectPhenotype(projectID, id, data.project, config)
            : await putProjectInfo(projectID, id, data.project, config)
          let newProject = response.data.data
          response.data.result && this.addToast('success', response.data.result.message)
          this.$emit('changeModal', {}, newProject)
        } catch (error) {
          this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        }
        this.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = false
        this.setLoadingAction(false)
      }
      await sendCase()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/projectEdit.vue